export const PASSPORT_URL_PREFIXES = {
  BETA_URL_PREFIX: 'beta.passport.transportation',
  GAMMA_URL_PREFIX: 'gamma.passport.transportation',
  PROD_URL_PREFIX: 'passport.transportation',
};

export const URL_PREFIXES_DEPRECATED = {
  BETA_URL_PREFIX: 'carrierhub.integ',
  GAMMA_URL_PREFIX: 'carrierhub-gamma.aka',
  PROD_URL_PREFIX: 'carrierhub.amazon',
};
export const URL_PREFIXES = {
  BETA_URL_PREFIX: 'carrierlogistics.integ',
  GAMMA_URL_PREFIX: 'carrierlogistics-gamma.aka',
  PROD_URL_PREFIX: 'carrierlogistics.amazon',
};
export const PUMS_CORAL_CONFIG = {
  // deprecated config will be removed
  BETA_CONFIG_DEPRECATED: 'Passport.BetaDeprecated.USAmazon',
  GAMMA_CONFIG_DEPRECATED: 'Passport.GammaDeprecated.USAmazon',
  PROD_CONFIG_DEPRECATED: 'Passport.ProdDeprecated.USAmazon',

  BETA_CONFIG: 'Carrierlogistics.Beta.USAmazon',
  GAMMA_CONFIG: 'Carrierlogistics.Gamma.USAmazon',
  PROD_CONFIG: 'Carrierlogistics.Prod.USAmazon',

  LOCAL_DEV: 'Base.Development',
};

export const PUMS_PASSPORT_CORAL_CONFIG = {
  BETA_CONFIG: 'Passport.Beta.USAmazon',
  GAMMA_CONFIG: 'Passport.Gamma.USAmazon',
  PROD_CONFIG: 'Passport.Prod.USAmazon',
};
